import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

import { EMAIL_PATTERN } from '../regex-patterns';

const validateEmail = (value?: string | null): { email: true } | null =>
  isEmpty(value) || EMAIL_PATTERN.test(value) ? null : { email: true };

export const emailValidator = (control: FormControl<string | null>) => validateEmail(control.value);
export const emailTrimValidator = (control: FormControl<string | null>) =>
  validateEmail(control.value && control.value.trim());
